import { useState, useEffect, useRef } from 'react';

function Ascii(props) {
    const ascii = {
//        crawler: "%20%20%20%20%20_______%20%20%20.-------.%20%20%20%20%20%20%20____%20%20%20%20.--.%20%20%20%20%20%20.--.%20%20.---.%20%20%20%20%20%20%20.-''-.%20%20.-------.%20%20%20%20%20%0A%20%20%20%20%2F%20%20%20__%20%20%5C%20%20%7C%20%20_%20_%20%20%20%5C%20%20%20%20.'%20%20__%20%60.%20%7C%20%20%7C_%20%20%20%20%20%7C%20%20%7C%20%20%7C%20%2C_%7C%20%20%20%20%20.'_%20_%20%20%20%5C%20%7C%20%20_%20_%20%20%20%5C%20%20%20%20%0A%20%20%20%7C%20%2C_%2F%20%20%5C__)%20%7C%20(%20'%20)%20%20%7C%20%20%20%2F%20%20%20'%20%20%5C%20%20%5C%7C%20_(%20)_%20%20%20%7C%20%20%7C%2C-.%2F%20%20)%20%20%20%20%2F%20(%20%60%20)%20%20%20'%7C%20(%20'%20)%20%20%7C%20%20%20%20%0A%20%2C-.%2F%20%20)%20%20%20%20%20%20%20%7C(_%20o%20_)%20%2F%20%20%20%7C___%7C%20%20%2F%20%20%7C%7C(_%20o%20_)%20%20%7C%20%20%7C%5C%20%20'_%20'%60)%20.%20(_%20o%20_)%20%20%7C%7C(_%20o%20_)%20%2F%20%20%20%20%0A%20%5C%20%20'_%20'%60)%20%20%20%20%20%7C%20(_%2C_).'%20__%20%20%20%20_.-%60%20%20%20%7C%7C%20(_%2C_)%20%5C%20%7C%20%20%7C%20%3E%20(_)%20%20)%20%7C%20%20(_%2C_)___%7C%7C%20(_%2C_).'%20__%20%20%0A%20%20%3E%20(_)%20%20)%20%20__%20%7C%20%20%7C%5C%20%5C%20%20%7C%20%20%7C.'%20%20%20_%20%20%20%20%7C%7C%20%20%7C%2F%20%20%20%20%5C%7C%20%20%7C(%20%20.%20%20.-'%20'%20%20%5C%20%20%20.---.%7C%20%20%7C%5C%20%5C%20%20%7C%20%20%7C%20%0A%20(%20%20.%20%20.-'_%2F%20%20)%7C%20%20%7C%20%5C%20%60'%20%20%20%2F%7C%20%20_(%20)_%20%20%7C%7C%20%20'%20%20%2F%5C%20%20%60%20%20%7C%20%60-'%60-'%7C___%5C%20%20%60-'%20%20%20%20%2F%7C%20%20%7C%20%5C%20%60'%20%20%20%2F%20%0A%20%20%60-'%60-'%20%20%20%20%20%2F%20%7C%20%20%7C%20%20%5C%20%20%20%20%2F%20%5C%20(_%20o%20_)%20%2F%7C%20%20%20%20%2F%20%20%5C%20%20%20%20%7C%20%20%7C%20%20%20%20%20%20%20%20%5C%5C%20%20%20%20%20%20%20%2F%20%7C%20%20%7C%20%20%5C%20%20%20%20%2F%20%20%0A%20%20%20%20%60._____.'%20%20''-'%20%20%20%60'-'%20%20%20'.(_%2C_).'%20%60---'%20%20%20%20%60---%60%20%20%60--------%60%20%60'-..-'%20%20''-'%20%20%20%60'-'%20%20%20%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20",
        crawler: "%20%20%20%20%20_______%20%20%20.-------.%20%20%20%20%20%20%20____%20%20%20%20.--.%20%20%20%20%20%20.--.%20%20.---.%20%20%20%20%20%20%20.-''-.%20%20.-------.%20%20%20%20%20%0A%20%20%20%20%2F%20%20%20__%20%20%5C%20%20%7C%20%20_%20_%20%20%20%5C%20%20%20%20.'%20%20__%20%60.%20%7C%20%20%7C_%20%20%20%20%20%7C%20%20%7C%20%20%7C%20%2C_%7C%20%20%20%20%20.'_%20_%20%20%20%5C%20%7C%20%20_%20_%20%20%20%5C%20%20%20%20%0A%20%20%20%7C%20%2C_%2F%20%20%5C__)%20%7C%20(%20'%20)%20%20%7C%20%20%20%2F%20%20%20'%20%20%5C%20%20%5C%7C%20_(%20)_%20%20%20%7C%20%20%7C%2C-.%2F%20%20)%20%20%20%20%2F%20(%20%60%20)%20%20%20'%7C%20(%20'%20)%20%20%7C%20%20%20%20%0A%20%2C-.%2F%20%20)%20%20%20%20%20%20%20%7C(_%20o%20_)%20%2F%20%20%20%7C___%7C%20%20%2F%20%20%7C%7C(_%20o%20_)%20%20%7C%20%20%7C%5C%20%20'_%20'%60)%20.%20(_%20o%20_)%20%20%7C%7C(_%20o%20_)%20%2F%20%20%20%20%0A%20%5C%20%20'_%20'%60)%20%20%20%20%20%7C%20(_%2C_).'%20__%20%20%20%20_.-%60%20%20%20%7C%7C%20(_%2C_)%20%5C%20%7C%20%20%7C%20%20%20(_)%20%20)%20%7C%20%20(_%2C_)___%7C%7C%20(_%2C_).'%20__%20%20%0A%20%20%20%20(_)%20%20)%20%20__%20%7C%20%20%7C%5C%20%5C%20%20%7C%20%20%7C.'%20%20%20_%20%20%20%20%7C%7C%20%20%7C%2F%20%20%20%20%5C%7C%20%20%7C(%20%20.%20%20.-'%20'%20%20%5C%20%20%20.---.%7C%20%20%7C%5C%20%5C%20%20%7C%20%20%7C%20%0A%20(%20%20.%20%20.-'_%2F%20%20)%7C%20%20%7C%20%5C%20%60'%20%20%20%2F%7C%20%20_(%20)_%20%20%7C%7C%20%20'%20%20%2F%5C%20%20%60%20%20%7C%20%60-'%60-'%7C___%5C%20%20%60-'%20%20%20%20%2F%7C%20%20%7C%20%5C%20%60'%20%20%20%2F%20%0A%20%20%60-'%60-'%20%20%20%20%20%2F%20%7C%20%20%7C%20%20%5C%20%20%20%20%2F%20%5C%20(_%20o%20_)%20%2F%7C%20%20%20%20%2F%20%20%5C%20%20%20%20%7C%20%20%7C%20%20%20%20%20%20%20%20%5C%5C%20%20%20%20%20%20%20%2F%20%7C%20%20%7C%20%20%5C%20%20%20%20%2F%20%20%0A%20%20%20%20%60._____.'%20%20''-'%20%20%20%60'-'%20%20%20'.(_%2C_).'%20%60---'%20%20%20%20%60---%60%20%20%60--------%60%20%60'-..-'%20%20''-'%20%20%20%60'-'%20%20%20%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20",
        about: "%20%20%20%20____%20%20%20%20%20_______%20%20%20%20%20%20%20%2C-----.%20%20%20%20%20%20___%20%20%20%20_%20%2C---------.%20%20%0A%20%20.'%20%20__%20%60.%20%5C%20%20____%20%20%5C%20%20%20.'%20%20.-%2C%20%20'.%20%20.'%20%20%20%7C%20%20%7C%20%7C%5C%20%20%20%20%20%20%20%20%20%20%5C%20%0A%20%2F%20%20%20'%20%20%5C%20%20%5C%7C%20%7C%20%20%20%20%5C%20%7C%20%20%2F%20%2C-.%7C%20%20%5C%20_%20%5C%20%7C%20%20%20.'%20%20%7C%20%7C%20%60--.%20%20%2C---'%20%0A%20%7C___%7C%20%20%2F%20%20%7C%7C%20%7C____%2F%20%2F%20%3B%20%20%5C%20%20'_%20%2F%20%20%7C%20%3A.'%20%20'_%20%20%7C%20%7C%20%20%20%20%7C%20%20%20%5C%20%20%20%20%0A%20%20%20%20_.-%60%20%20%20%7C%7C%20%20%20_%20_%20'.%20%7C%20%20_%60%2C%2F%20%5C%20_%2F%20%20%7C'%20%20%20(%20%5C.-.%7C%20%20%20%20%3A_%20_%3A%20%20%20%20%0A%20.'%20%20%20_%20%20%20%20%7C%7C%20%20(%20'%20)%20%20%5C%3A%20(%20%20'%5C_%2F%20%5C%20%20%20%3B'%20(%60.%20_%60%20%2F%7C%20%20%20%20(_I_)%20%20%20%20%0A%20%7C%20%20_(%20)_%20%20%7C%7C%20(_%7B%3B%7D_)%20%7C%20%5C%20%60%22%2F%20%20%5C%20%20)%20%2F%20%7C%20(_%20(_)%20_)%20%20%20(_(%3D)_)%20%20%20%0A%20%5C%20(_%20o%20_)%20%2F%7C%20%20(_%2C_)%20%20%2F%20%20'.%20%5C_%2F%60%60%22.'%20%20%20%5C%20%2F%20%20.%20%5C%20%2F%20%20%20%20(_I_)%20%20%20%20%0A%20%20'.(_%2C_).'%20%2F_______.'%20%20%20%20%20'-----'%20%20%20%20%20%20%60%60-'%60-''%20%20%20%20%20'---'%20%20%20%20%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20",
        home: "%20%20______%20%20%20%20%20.-------.%20%20%20.-.%2F%60)%20%20________%20%2C---------.%20.-.%2F%60)%20%2C---.%20%20%20.--.%20%20.-_'''-.%20%20%20%20%0A%20%7C%20%20%20%20_%20%60''.%20%7C%20%20_%20_%20%20%20%5C%20%20%5C%20.-.')%7C%20%20%20%20%20%20%20%20%7C%5C%20%20%20%20%20%20%20%20%20%20%5C%5C%20.-.')%7C%20%20%20%20%5C%20%20%7C%20%20%7C%20'_(%20)_%20%20%20%5C%20%20%20%0A%20%7C%20_%20%7C%20)%20_%20%20%5C%7C%20(%20'%20)%20%20%7C%20%20%2F%20%60-'%20%5C%7C%20%20%20.----'%20%60--.%20%20%2C---'%2F%20%60-'%20%5C%7C%20%20%2C%20%20%5C%20%7C%20%20%7C%7C(_%20o%20_)%7C%20%20'%20%20%0A%20%7C(%20''_'%20%20)%20%7C%7C(_%20o%20_)%20%2F%20%20%20%60-'%60%22%60%7C%20%20_%7C____%20%20%20%20%20%7C%20%20%20%5C%20%20%20%20%60-'%60%22%60%7C%20%20%7C%5C_%20%5C%7C%20%20%7C.%20(_%2C_)%2F___%7C%20%20%0A%20%7C%20.%20(_)%20%60.%20%7C%7C%20(_%2C_).'%20__%20.---.%20%7C_(%20)_%20%20%20%7C%20%20%20%20%3A_%20_%3A%20%20%20%20.---.%20%7C%20%20_(%20)_%5C%20%20%7C%7C%20%20%7C%20%20.-----.%20%0A%20%7C(_%20%20%20%20._)%20'%7C%20%20%7C%5C%20%5C%20%20%7C%20%20%7C%7C%20%20%20%7C%20(_%20o._)__%7C%20%20%20%20(_I_)%20%20%20%20%7C%20%20%20%7C%20%7C%20(_%20o%20_)%20%20%7C'%20%20%5C%20%20'-%20%20%20.'%20%0A%20%7C%20%20(_.%5C.'%20%2F%20%7C%20%20%7C%20%5C%20%60'%20%20%20%2F%7C%20%20%20%7C%20%7C(_%2C_)%20%20%20%20%20%20%20(_(%3D)_)%20%20%20%7C%20%20%20%7C%20%7C%20%20(_%2C_)%5C%20%20%7C%20%5C%20%20%60-'%60%20%20%20%7C%20%20%0A%20%7C%20%20%20%20%20%20%20.'%20%20%7C%20%20%7C%20%20%5C%20%20%20%20%2F%20%7C%20%20%20%7C%20%7C%20%20%20%7C%20%20%20%20%20%20%20%20%20(_I_)%20%20%20%20%7C%20%20%20%7C%20%7C%20%20%7C%20%20%20%20%7C%20%20%7C%20%20%5C%20%20%20%20%20%20%20%20%2F%20%20%0A%20'-----'%60%20%20%20%20''-'%20%20%20%60'-'%20%20'---'%20'---'%20%20%20%20%20%20%20%20%20'---'%20%20%20%20'---'%20'--'%20%20%20%20'--'%20%20%20%60'-...-'%20%20%20%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20"
        }
    return (
        decodeURIComponent(ascii[props.section]).replace(/&gt;/g, "<")
    )
}

function Header(props) {
    const ascii= `



    
-------------------------------------------------------------------------------------
 NEW SESSION
 @time@

`;
    return (
        ascii.replace("@time@", new Date().toUTCString())
    )
}

function Footer(props) {
    const ascii= `

  (EOF)
`;
    return (
        ascii
    )
}

function Row(props) {
    let spacing = Array(18-props.label.length).fill(" ").join('');

    const ascii = `
  ${props.label}${spacing}${props.content||""}
 -------------------------------------------------------------------------------------`;
    return (
        ascii
    )
}

function Entry(props) {
    const ascii =  `
  ${props.children}
 -------------------------------------------------------------------------------------`;
    return (
        ascii
    )
}

function About(props) {
    return(
        <>
        <Ascii section="about" />
        <Row label="PROJECT STATS" />
        <Row label="Author" content={props.data.author} />
        <Row label="Mint price" content={`${props.data.ethfloor}`}/> 
        <Row label="Minted" content={`${props.data.minted} / ${props.data.total}`}/>
        {(props.data.totalsales) && (<Row label="Secondary sales" content={props.data.totalsales}/>)}

        
        </>
    )
}

function Home(props) {
    return(
        <>
        <Ascii section="home" />
        <Row label="PROJECT UPDATES"/>
        {props.data.map((e,i)=><Entry key={i}>{`${e.time}\n  ${e.title}  ${e.subtitle?"\n"+e.subtitle:""}`}</Entry>)}
        </>
    )
}

function Crawler(props) {
    return(
        <>
        <Ascii section="crawler" />
        <Row label="CRAWLER STATS"/>
        {props.data.map((e,i)=><Entry key={i}>{`${e.time}\n  ${e.title}  ${e.subtitle?"\n  "+e.subtitle:""}`}</Entry>)}
        </>
    )
}

function Code(props) {
    let currentLine = 0;
    const sourceRef = useRef(null);
    const intervalRef = useRef(null);
    const codeShow = () => {
        const showLineByLine= () => {
            if (currentLine < codeData.length-1) { 
                currentLine++;
                setCodeContent(codeContent => codeContent + codeData[currentLine] + "\n");
                setIsPlaying(true);
            } else {
                clearInterval(intervalRef.current);
                setIsPlaying(false);
            }
        }
        currentLine = 0;
        let codeData = sourceRef.current.innerHTML.split(/\r?\n/);
        intervalRef.current = setInterval(showLineByLine, 100);
    }
    const [isPlaying, setIsPlaying] = useState(false);
    const [codeContent, setCodeContent] = useState("");
    useEffect(() => { 
        if (isPlaying) { 
            clearInterval(intervalRef.current); 
            setIsPlaying(false);
        }
        setCodeContent("");
        codeShow();
    }, [props.section]);

    const section = {
        "about":    <About data={props.data.stats} />,
        "home":     <Home data={props.data.updates.project} />,
        "crawler":  <Crawler data={props.data.updates.crawler} />
    }[props.section]
   
    return (
        <>
            <div className="is-hidden"  ref={sourceRef}>
                <Header/>
                    {section}
                <Footer/>
            </div>
            <div id="code" className="is-hidden-tablet-only is-hidden-mobile is-size-4">
            {codeContent}
            </div>
        </>
    )
}

export default Code;
 

/*
 const codeHide = () => {
        const hideLineByLine= () => {
            if (currentLine > 0) { 
                currentLine -= 4;
                setCodeContent("");
                for (let i = 0; i < currentLine; i++) {
                    setCodeContent(codeContent => codeContent + codeData[i] + "\n");
                }
                setIsPlaying(true);
            } else {
                clearInterval(intervalRef.current);
                setIsPlaying(false);
            }
        }
        let codeData = sourceRef.current.innerHTML.split(/\r?\n/);
        currentLine = codeData.length-1;
        intervalRef.current = setInterval(hideLineByLine, 200);
    }
*/